import React, { useEffect, useMemo, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import * as yup from 'yup';
import { useFormik } from 'formik';

import ProductsListBox from '../../components/inventorymng/ProductsListBox';
import ProductsList from '../../components/inventorymng/ProductsList';
import { listInventoryStocks, unloadInventoryStocks } from '../../modules/inventoryModule/invStocks';


const WarehouseInventoryListContainer = () => {

  const dispatch = useDispatch();
  const [searchKeyword, setSearchKeyword] = useState("productNm");
  const [searchWords, setSearchWords] = useState(null);

  const { stocks, loading } = useSelector(
    ({ inventoryModule, loading }) => ({
      stocks: inventoryModule.invStocks.stocks,
      loading: loading['inventory/LIST_INV_STOCKS'],
    }),
  );

  // 컴포넌트 마운트 후 list 데이터 요청
  useEffect(() => {
    dispatch(listInventoryStocks());
    return () => unloadInventoryStocks();
  }, []);


  const searchList = (values) => {
    let searchData = {
      [searchKeyword]: values.searchWords,
    };
    setSearchKeyword(values.searchKeyword);
    setSearchWords(values.searchWords);

    dispatch(listInventoryStocks(searchData));
  }

  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable()
  });

  const formik = useFormik({
    initialValues: { searchKeyword: searchKeyword, searchWords: searchWords },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      setTimeout(() => {
        searchList(values);
        setSubmitting(false);
      }, 1000);
    },
  });

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'whUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'stockUuid',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'productUuid',
        hide: true,
        type: 'string',
        editable: false,
      },

      {
        field: 'masPartnerNm',
        headerName: '제조사',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'pricePartnerNm',
        headerName: '매입처',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'category',
        headerName: '분류',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: true,
      },
      {
        field: 'modelNm',
        headerName: '모델명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productNm',
        headerName: '제품명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'productCnt',
        headerName: '수량',
        minWidth: 100,
        flex: 0.5,
        description: '',
        align: 'center',
        headerAlign: 'right',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `${valueFormatted}`;
        },
      },
      {
        field: 'priceVal',
        headerName: '가격',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
        valueFormatter: (params) => {
          const valueFormatted = Number(params.value).toLocaleString('ko-KR');
          return `₩ ${valueFormatted}`;
        },
      },
    ],
    [],
  );

  return (
    <div>

      <ProductsListBox formik={formik} />
      <ProductsList
        columns={columns}
        rows={stocks}
        loading={loading}
      />
    </div>
  )
}

export default WarehouseInventoryListContainer